import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Button } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { TestimonialRecordFieldsFragment } from 'GraphQL/DatoCMS/TypedDocuments'

import Gallery from './Gallery'
import { Container } from './styles'

type Props = {
  data?: TestimonialRecordFieldsFragment[]
  onAction?: () => void
}

function TestimonialsSection({ data, onAction }: Props) {
  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container px={LANDING_CONTENT_PX} py={[44, 44, 80, 80, 100]}>
          <SubsectionTitle
            centered
            subtitle="Here’s what your future network has to say about Emajin."
            title="Testimonials"
          />

          <Gallery data={data} />

          <Button large onClick={onAction}>
            Join Us Today
          </Button>
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default TestimonialsSection
